export enum StatusTypes {
  SUCCESS = 'success',
  ERROR = 'error',
}
